import React, { Fragment } from 'react';
import TextArea from '../../../../../components/input/TextArea/TextArea';
import SearchBox from '../../../../../components/outline/SearchBox';
import Select from '../../../../../components/input/Select';
import BaseForm from '../../../../../components/form/BaseForm';
import ButtonList from '../../../../../components/ButtonList';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CheckBox from '../../../../../components/input/CheckBox';
import { DATE_FORMAT, QUICK_DATE_SELECT_BUTTON_TARGET } from '../../../../../constants/service/common/utilConstants';
import {
  SEARCH_ORDER_STATUS_CHECK_BOX_LIST,
  ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST,
  ORDER_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST,
  ORDER_ITEM_PERIOD_SEARCH_TYPE_SELECT_LIST,
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  MAXIMUM_NUMBER_OF_ORDER_DETAIL_SEARCH_WORD,
  ORDER_GIFT_STATUS_SELECT_LIST,
  ORDER_TYPE_SELECT_LIST,
  ORDER_TYPE,
} from '../../../../../constants/service/app/orderConstants';
import { PRODUCT_MANAGEMENT_TYPE_SELECT_LIST } from '../../../../../constants/service/app/productConstants';
import { BRAND_SEARCH_TYPE_SELECT_LIST } from '../../../../../constants/service/app/brandConstants';
import { setClearDash, setIfNull, setQuickToDate, setQuickToDateTime, setTrim } from '../../../../../lib/common';
import './OrderManagementListSearchBox.scss';

const OrderManagementListSearchBox = (props) => {
  const { setData, searchData, onSearch, onClear } = props;
  const {
    orderItemStatusList,
    deliveryType,
    orderItemDetailSearch,
    viewPeriod,
    productType,
    store,
    orderTypeList,
    giftStatusList,
  } = searchData;

  return (
    <SearchBox className="order-management-list-search-box" onSearch={() => onSearch()} onClear={() => onClear()}>
      <BaseForm
        label="주문상태"
        content={
          <Fragment>
            {SEARCH_ORDER_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={orderItemStatusList.includes(item.id)}
                onChange={(checked) =>
                  setData({
                    path: ['orderItemStatusList'],
                    value: checked
                      ? [...orderItemStatusList, item.id]
                      : orderItemStatusList.filter((id) => item.id !== id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      <BaseForm
        label="배송방법"
        content={
          <Select
            list={ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST}
            onChange={(id) =>
              setData({
                path: ['deliveryType'],
                value: id,
              })
            }
            value={deliveryType}
            isTable={true}
          />
        }
      />

      <BaseForm
        label="상세 검색"
        content={
          <Fragment>
            <Select
              list={ORDER_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST}
              onChange={(id) =>
                setData({
                  path: ['orderItemDetailSearch', 'type'],
                  value: id,
                })
              }
              value={orderItemDetailSearch.type}
              isTable={true}
            />

            <TextArea
              value={orderItemDetailSearch.value}
              maxLength={MAXIMUM_NUMBER_OF_ORDER_DETAIL_SEARCH_WORD}
              placeholder={`상품 ID, 주문번호, 상품 주문번호, 브랜드 ID를 검색하는 경우 ","구분자를 이용하여 여러 주문 건을 검색할 수 있습니다. `}
              onChange={(value) => {
                setData({
                  path: ['orderItemDetailSearch', 'value'],
                  value: setIfNull(setTrim(setClearDash(value))),
                });
              }}
              onPressEnter={() => onSearch()}
            />
          </Fragment>
        }
      />

      <BaseForm
        label="상품 타입"
        content={
          <Fragment>
            {PRODUCT_MANAGEMENT_TYPE_SELECT_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={productType.includes(item.id)}
                onChange={(checked) =>
                  setData({
                    path: ['productType'],
                    value: checked ? [...productType, item.id] : productType.filter((id) => item.id !== id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      <BaseForm
        label="관리처"
        content={
          <Fragment>
            {BRAND_SEARCH_TYPE_SELECT_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={store.includes(item.id)}
                onChange={(checked) =>
                  setData({
                    path: ['store'],
                    value: checked ? [...store, item.id] : store.filter((id) => item.id !== id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      <BaseForm
        label="조회기간"
        content={
          <Fragment>
            <Select
              list={ORDER_ITEM_PERIOD_SEARCH_TYPE_SELECT_LIST}
              onChange={(id) =>
                setData({
                  path: ['viewPeriod', 'type'],
                  value: id,
                })
              }
              value={viewPeriod.type}
              isTable={true}
            />

            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={viewPeriod.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['viewPeriod'],
                  value: setQuickToDateTime({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: viewPeriod.period,
                    type: viewPeriod.type,
                  }),
                })
              }
            />

            <div className="date-search">
              <DateRangePicker
                value={viewPeriod.period}
                showTime={true}
                outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                format={DATE_FORMAT.FULL_DASH_FORMAT}
                btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                startText={DATE_FORMAT.FULL_DASH_FORMAT}
                endText={DATE_FORMAT.FULL_DASH_FORMAT}
                onSelect={(period) =>
                  setData({
                    path: ['viewPeriod'],
                    value: setQuickToDate({
                      period,
                      type: viewPeriod.type,
                    }),
                  })
                }
              />
            </div>
          </Fragment>
        }
      />

      <BaseForm
        label="주문 타입"
        content={
          <Fragment>
            {ORDER_TYPE_SELECT_LIST.map((item) => (
              <CheckBox
                key={item.id}
                value={item.id}
                text={item.name}
                checked={orderTypeList.includes(item.id)}
                onChange={(checked) => {
                  // 주문 타입으로 선물 타입이 체크해제 되었을 경우 하위의 선물 상태도 모두 해제함
                  if (item.id === ORDER_TYPE.GIFT) {
                    if (!checked) {
                      setData({
                        path: ['giftStatusList'],
                        value: [],
                      });
                    }
                  }

                  setData({
                    path: ['orderTypeList'],
                    value: checked ? [...orderTypeList, item.id] : orderTypeList.filter((id) => item.id !== id),
                  });
                }}
              />
            ))}
          </Fragment>
        }
      />

      {orderTypeList.includes(ORDER_TYPE.GIFT) && (
        <BaseForm
          label="선물 상태"
          content={
            <Fragment>
              {ORDER_GIFT_STATUS_SELECT_LIST.map((item) => (
                <CheckBox
                  key={item.id}
                  value={item.id}
                  text={item.name}
                  checked={giftStatusList.includes(item.id)}
                  onChange={(checked) =>
                    setData({
                      path: ['giftStatusList'],
                      value: checked ? [...giftStatusList, item.id] : giftStatusList.filter((id) => item.id !== id),
                    })
                  }
                />
              ))}
            </Fragment>
          }
        />
      )}
    </SearchBox>
  );
};

export default OrderManagementListSearchBox;
